<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="42%"
    side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Rune"
    panel-color="transparent"
    :z-index="5000"
  >
    <template #default>
      <div class="mt-2 px-4">
        <RuneCard
          :rune="rune"
          :character="character"
          @add-character-rune="$emit('add-character-rune', $event)"
          @update-character-rune="$emit('update-character-rune', $event)"
          @delete-character-spell="forwardDeleteCharacterSpell"
          @delete-character-rune="$emit('delete-character-rune', $event)"
          @close-rune-panel="$emit('close-rune-panel', $event)"
        />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import RuneCard from './RuneCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
//---------
// scripts
//---------
export default {
  name: 'RuneSidePanel',
  emits: [
    'add-character-rune',
    'update-character-rune',
    'delete-character-spell',
    'delete-character-rune',
    'close-rune-panel',
  ],
  //------------
  // components
  //------------
  components: {
    VueSidePanel,
    RuneCard,
  },
  //-------
  // props
  //-------
  props: {
    rune: {
      type: Object,
      required: false,
      default: null,
    },
    character: {
      type: Object,
      required: true,
      default: null,
    },
  },
  //------
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true, // mandatory for VueSidePanel
    }
  },
  //---------
  // methods
  //---------
  methods: {
    forwardDeleteCharacterSpell(...args) {
      this.$emit('delete-character-spell', ...args)
    },
  },
  //---------
  // mounted
  //---------
  mounted() {},
}
</script>

<style scoped>
.vsp-overlay {
  background: #1e1e1e !important;
  opacity: 0.2 !important;
}
</style>
